import React, { ReactNode } from "react";
import { Geolocation } from "src/utils/localization/geolocation/geolocation";
import { getCurrentGeolocation } from "./geolocationLoader";
import { isSSR } from "../../ssr";

const defaultState: Geolocation = {
  countryCode: undefined,
  countryCodeISO3: undefined,
  defaultCurrency: "USD",
  market: undefined,
  phone: undefined,
  unit: undefined
};

interface GeolocationProviderProps {
  children: ReactNode;
}

const GeolocationContext = React.createContext(defaultState);
class GeolocationProvider extends React.Component<
  GeolocationProviderProps,
  Geolocation
> {
  constructor(props: GeolocationProviderProps) {
    super(props);
    this.state = defaultState;
  }

  componentDidMount(): void {
    if (!isSSR()) {
      getCurrentGeolocation().then((geolocation) =>
        this.setState(() => geolocation)
      );
    }
  }

  render(): ReactNode {
    const { children } = this.props;

    return (
      <GeolocationContext.Provider
        value={{
          ...this.state
        }}
      >
        {children}
      </GeolocationContext.Provider>
    );
  }
}

export function useGeolocation(): Geolocation {
  return React.useContext(GeolocationContext);
}

export default GeolocationContext;
export { GeolocationProvider };
